import "./app.scss";
import ServiceForm from "./components/ServiceForm";
import desktop from "./assets/images/Desktop.png";
import mobile from "./assets/images/Mobile.png";
import "./assets/scss/cconsent-bar.css";
function App() {
    return (
        <>
            <nav className="header">
                <div className="top-row">
                    <a className="logo-wrapper" href="https://www.skoda.pl/" target="_self"></a>
                </div>
                <div className="bottom-row">
                    <a href="https://www.skoda.pl/" target="_self">Przejdź do&nbsp;strony głównej</a>
                </div>
            </nav>
            <div className="main-container">
                <div className="main-image">
                    <img src={desktop} className="background-image" alt=""/>
                    <img src={mobile} className="background-image-mobile" alt=""/>
                </div>
            </div>
            <div className="form-outer-container">
                <div className="form-bg">
                    <ServiceForm/>
                </div>
            </div>
        </>
    );
}

export default App;
